export default __webpack_public_path__ + "static/media/notification.ef4f8189.svg";